<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="/dashboard/">
        <img
          class="navbar-brand-full"
          src="img/brand/Teleste.jpg"
          width="100"
          height="45"
          alt="CoreUI Logo"
          style="object-fit: cover;"
        />
        <img
          class="navbar-brand-minimized"
          src="img/brand/part.png"
          width="20"
          height="20"
          alt="Fiber Node Services"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen="true" />
      <b-navbar-nav class="d-md-down-none">
        <b-form-input
          style="display:inline-block; width:150px;margin-left:150px"
          v-model="searchQuery"
          type="search"
          id="filterInput"
          placeholder="Type to Search"
        ></b-form-input>
        <b-form-select id="basicSelect"
                       :plain="true"
                       :options="[{text:'Serial', value:'serialNumber'}]"
                       placeholder="Please select"
                       v-model="selected"
                       text-field="text"
                       value-field="value">
        </b-form-select>
        <b-button
          :disabled="searchQuery ? false : true"
          @click="searchFor()"
        >Search </b-button>
      </b-navbar-nav>
      <b-navbar-nav class="d-md-down-none" style="margin:auto;"> </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav style="width: 230px" :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <div style="padding-top: 17px" class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <TheFooter>
      <div></div>
      <div class="ml-auto">
        <a href="https://www.fibernode.com/main/">Fiber Node Services Inc.</a>
        <span class="ml-1">&copy; 2020</span>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from "@/utils/_nav";
import {
  Aside as AppAside,
  AsideToggler,
  Breadcrumb,
  Footer as TheFooter,
  Header as AppHeader,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  SidebarToggler
} from "@coreui/vue";
import axi from "axios";
import DefaultAside from "./DefaultAside";
import DefaultHeaderDropdownAccnt from "./DefaultHeaderDropdownAccnt";
export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data() {
    return {
      nav: nav.items,
      full_name: "",
      ip: "",
      selected: "serialNumber",
      searchQuery: null,
    };
  },
  methods: {
    searchFor() {
      const { type, value } = this.$route.query;
      if (type !== this.selected  || value !== this.searchQuery) {
        this.$router.push('/search/?type=' + this.selected + '&value=' + this.searchQuery);
      }
    },
    getUserData() {
      axi.get("https://www.cloudflare.com/cdn-cgi/trace").then(res => {
        const ipRegex = /[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}/;
        const IP = res.data.match(ipRegex)[0];
        this.ip = IP;
        this.logData();
      });
    },
    logData() {
      let formData = new FormData();
      formData.append("portal", "teleste");
      formData.append("ip", this.ip);
      formData.append("user", localStorage.getItem("arr_user"));
      this.$http
        .post("api/logUser.php", formData)
        .then()
        .catch(err => {
          console.log(err);
        });
    }
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    }
  },
  mounted() {
    this.full_name = localStorage.getItem("arr_full_name");
  },
  created() {
    this.getUserData();
  }
};
</script>

<style>
.sidebar .nav {
  width: 225px;
}
html:not([dir="rtl"]) .sidebar {
  margin-left: -225px;
}
@media (min-width: 992px) {
  .sidebar-minimized .sidebar .sidebar-nav {
    overflow: visible;
    width: 50px !important;
  }
}
</style>
